import { render } from "./index.vue?vue&type=template&id=df2f1368&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=df2f1368&lang=less"

import exportComponent from "/data/jenkins/workspace/ecom_ecom-offical-website_node_sharelib_cicd/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__